/**
     * @desc 查询NFT合约
传入item的id，查询NFT合约信息
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/nftContract/getNFTContractByItemId', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/nftContract/getNFTContractByItemId', params);
}
